import { faBook, faHandPointRight, faPeopleRoof, faPhone, faSignal } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdmissionTeacher from './AdmissionTeacher';
import swal from 'sweetalert';

const AdmissionCourseDetails = () => {
    const [course, setCourse] = useState({});
    const [loadding, setLoadding] = useState(true);
    const [show, setShow] = useState(false);

    const { id } = useParams();

    useEffect(() => {
        fetch(`https://one0m-backend2.onrender.com/freePaid/${id}`)
            .then(res => res.json())
            .then(data => {
                setCourse(data?.freeCourse);
                setLoadding(false);
            })
            .catch(err => {
                setLoadding(true)
            })
    }, [id])


    //handleJoint 
    const handleJoint = () => {
        swal("WOW!", "কোর্সটি সম্পর্কে বিস্তারিত জানতে ফোন করুন 16910!", "success");
    }

    return (
        <section style={{ marginTop: '100px' }}>
            {
                loadding ? <>
                    <div class="d-flex justify-content-center">
                        <div class="spinner-grow text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-secondary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-success" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-danger" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-warning" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-dark" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </> :
                    <div className='container-fluid p-5' style={{ marginTop: '50px' }}>
                        <div className="row gy-5">
                            <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                                <div className="paid-details">
                                    <h1 className='fw-bold fs-2 mb-3'>{course?.courseTitle}</h1>
                                    <div className="paid-sub cBorder p-3">
                                        {/* ==============Course outline================ */}
                                        <div className="row gy-4">
                                            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                                                <div className="sub-item text-center">
                                                    <div className='rounded-pill d-flex align-items-center justify-content-center d-block mx-auto' style={{ height: '60px', width: '60px', background: '#FFECC2' }}>
                                                        <FontAwesomeIcon icon={faSignal} size='2x' className='text-danger' />
                                                    </div>
                                                    <h5 className='mt-2 mb-2'>লাইভ ক্লাস এবং লেকচার শীট</h5>
                                                    <h5>{course?.live} টি</h5>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                                                <div className="sub-item text-center">
                                                    <div className='rounded-pill d-flex align-items-center justify-content-center d-block mx-auto' style={{ height: '60px', width: '60px', background: '#FFECC2' }}>
                                                        <FontAwesomeIcon icon={faPeopleRoof} size='2x' className='text-danger' />
                                                    </div>
                                                    <h5 className='mt-2 mb-2'>রিভিশন ক্লাস</h5>
                                                    <h5>{course?.revision} টি</h5>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                                                <div className="sub-item text-center">
                                                    <div className='rounded-pill d-flex align-items-center justify-content-center d-block mx-auto' style={{ height: '60px', width: '60px', background: '#FFECC2' }}>
                                                        <FontAwesomeIcon icon={faBook} size='2x' className='text-danger' />
                                                    </div>
                                                    <h5 className='mt-2 mb-2'>পূর্ণাঙ্গ মডেল টেস্ট</h5>
                                                    <h5>{course?.test} টি</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* =================Teachers================ */}
                                    <div className="teacher">
                                        <h5 className='fw-bold mb-5 fs-3 mt-5'>শিক্ষকবৃন্দ</h5>
                                        <div className="row gy-3 cBorder pb-2">
                                            {
                                                course?.teachersProfile?.map(tea => <AdmissionTeacher tea={tea} key={tea?.title} />)
                                            }
                                        </div>
                                    </div>
                                    {/* ==============About Course============== */}
                                    <div className="about-course mt-5">
                                        <h5 className='fw-bold mb-2 fs-3 mt-5'>কোর্সটি সম্পর্কে </h5>
                                        <p className='fs-5'>
                                            {show ? course?.aboutCourse : course?.aboutCourse?.slice(0, 250)}
                                            <div className="btn text-danger" onClick={() => setShow(!show)}>Read More <FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></div>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                                <div className="paid-details">
                                    <div className="course-intro">
                                        <iframe width="560" height="315" src={`https://www.youtube.com/embed/${course?.entryVideo}`} title="YouTube video player" frameborder="1" className='w-100' allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </div>
                                </div>
                                <div className="price text-end">
                                    <h5 className='fw-bold'><span className='fs-2 me-2'>৳</span>{course?.price}</h5>
                                </div>
                                <div className="btn btn-success w-100 d-block fs-5 mt-3" onClick={handleJoint}> জয়েন করুন  <FontAwesomeIcon icon={faHandPointRight} className='ms-1' /></div>
                                <div className="phoneCall mt-5">
                                    <h5 className='fs-5 fw-bold'>কোর্সটি সম্পর্কে বিস্তারিত জানতে <span className='text-primary'><FontAwesomeIcon icon={faPhone} /> ফোন করুন (16910)</span></h5>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </section>
    );
};

export default AdmissionCourseDetails;